module.exports = __webpack_public_path__ + "img/pattern-divider-desktop.a03cc981.svg";